(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda appointment info 
    module.controller('AgendaAppointmentInfoController',
        ['$uibModalInstance', 'appointment', 'AppointmentService', 'Alert', '$translate', AgendaAppointmentInfoControllerFn]);

    function AgendaAppointmentInfoControllerFn($uibModalInstance, appointment, AppointmentService, Alert, $translate) {
        var vm = this;

        // current appointment
        vm.appointment = null;

        activate();

        // cancel
        vm.cancel = function () {
            $uibModalInstance.close();
        };

        vm.saveContent = function() {
            var content = vm.appointment.content || '';
            AppointmentService.content(vm.appointment.id, content).then(function (result) {
                Alert.success($translate.instant('appointment_content_updated_successfully'));
                $uibModalInstance.close(vm.appointment.content);
            });
        };

        // activation work
        function activate() {
            vm.appointment = appointment;
        } // activate

    }

})();